// extracted by mini-css-extract-plugin
export var alternate = "Button-mps-module--alternate--12f59";
export var base = "Button-mps-module--base--d9965";
export var button = "Button-mps-module--button--f3db3";
export var disabled = "Button-mps-module--disabled--2c8cc";
export var flat = "Button-mps-module--flat--b1e3c";
export var fullWidth = "Button-mps-module--fullWidth--593d2";
export var ghost = "Button-mps-module--ghost--7304f";
export var greyBtn = "Button-mps-module--greyBtn--36610";
export var large = "Button-mps-module--large--03574";
export var link = "Button-mps-module--link--3db57";
export var link2 = "Button-mps-module--link2--c66bc";
export var primary = "Button-mps-module--primary--5a6ec";
export var secondary = "Button-mps-module--secondary--55633";
export var small = "Button-mps-module--small--c3f67";
export var smallest = "Button-mps-module--smallest--45935";
export var tertiary = "Button-mps-module--tertiary--c8636";